const TEAM_ID_KEY = 'selectedTeamId';
const TEAM_NAME_KEY = 'selectedTeamName';

export const getSelectedTeam = () => ({
  id: localStorage.getItem(TEAM_ID_KEY) || null,
  name: localStorage.getItem(TEAM_NAME_KEY) || null,
});

export const setSelectedTeam = (id, name) => {
  if (id) {
    localStorage.setItem(TEAM_ID_KEY, id);
    localStorage.setItem(TEAM_NAME_KEY, name || '');
  } else {
    localStorage.removeItem(TEAM_ID_KEY);
    localStorage.removeItem(TEAM_NAME_KEY);
  }
  // Let any mounted component (e.g. the sidebar's Team Context selector)
  // know the active team changed, even when the change came from somewhere
  // else in the app (e.g. opening a team's Manage Admins page) rather than
  // from the dropdown itself.
  window.dispatchEvent(new CustomEvent('team-context-changed'));
};

export const getToken = () => {
  return localStorage.getItem('token');
};

export const setToken = (token) => {
  localStorage.setItem('token', token);
};

export const removeToken = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  setSelectedTeam(null);
};

export const getUser = () => {
  const raw = localStorage.getItem('user');
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const setUser = (user) => {
  localStorage.setItem('user', JSON.stringify(user));
};

export const isAuthenticated = () => {
  return !!getToken();
};

export const isAdmin = () => {
  const user = getUser();
  return !!(user && user.role === 'admin');
};

export const isSecurityManager = () => {
  const user = getUser();
  return !!(user && user.role === 'security_manager');
};